const header = {
  // all the properties are optional - can be left empty or deleted
  title: 'Sabbagh',
}

const about = {
  name: 'Sara Sabbagh',
  role: 'Full Stack Engineer',
  description: [
    "I'm a passionate full-stack software engineer with a background in customer success, recruitment, and sales—bringing people-first energy into everything I do.After several years leading teams and driving growth in fintech and startups, I pivoted into tech, where I’ve spent the last two years building accessible, high-impact digital products for public and private sector clients.",
    'I thrive in collaborative, agile teams and love taking on new challenges—whether that means learning a new language like Nunjucks on the fly or integrating AI into real-world tools.',
    'Fluent in both English and Spanish, I bring strong communication, leadership, and coaching skills alongside my technical toolkit: TypeScript, Python, React, Node.js, AWS, and more.',
    'I’m now looking for my next opportunity to keep growing as a developer and continue making a difference through technology.',
  ],
  resume: './assets/sarasabbagh2025.pdf',
  social: {
    linkedin: 'https://www.linkedin.com/in/sara-sabbagh/',
    github: 'https://github.com/Saraesabbagh',
  },
}

const projects = [
  {
    name: 'Gov Uk Task List',
    description: 'Full stack application example using Gov design systems',
    stack: ['Node', 'TypeScript', 'Nunjucks', 'docker', 'Prisma ORM'],
    sourceCode: 'https://github.com/sarasabbaghcyb/dts-frontend',
    livePreview: 'https://youtu.be/5MEXEdzilbk',
    image: './assets/gov.png',
  },
  {
    name: 'Facebook',
    description:
      'Fake facebook built as a freelancer. Appeared in BAFTA nominated short film about cyber Trolling. Full authentication and functionality',
    stack: ['MongoDB', 'TypeScript', 'React', 'vercel', 'rendr'],
    sourceCode: 'https://github.com/Saraesabbagh/v3-fb',
    livePreview: 'https://v3-fb.vercel.app/',
    image: './assets/facebook.png',
  },
  {
    name: 'Guess the Disney Character full stack game',
    description:
      'Built as part of a technical test for another role became one of the funnest technicals so far. Working with the Disney public API to create a fun character game',
    stack: ['Node', 'JavaScript', 'React', 'third party API'],
    sourceCode: 'https://github.com/Saraesabbagh/cyb4',
    livePreview: 'https://cyb4.vercel.app/',
    image: './assets/disney.png',
  },
]

const skills = [
  'HTML',
  'CSS',
  'JavaScript',
  'TypeScript',
  'React',
  'Python',
  'Ruby on rails',
  'AWS',
  'Tailwind',
  'Material UI',
  'Git',
  'CI/CD',
  'Jest',
  'Cypress',
  'Pytest',
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'sarasabbagh@mail.co.uk',
}

export { header, about, projects, skills, contact }
